/**
 * Checks sessionStorage for a pending event booking and returns
 * the event detail route if one exists, otherwise null.
 */
export function getPendingEventRedirect(): string | null {
  try {
    const pending = sessionStorage.getItem("pending_event_booking");
    if (pending) {
      const { eventId, eventSlug } = JSON.parse(pending);
      if (eventId) {
        return eventSlug
          ? `/events/${eventSlug}/${eventId}`
          : `/events/${eventId}`;
      }
    }
  } catch {
    // parse error, ignore
  }
  return null;
}
